<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.memberstatus" placeholder="请选择"
                        allowClear>
                <!-- <a-select-option value="0">报名草稿</a-select-option> -->
                <a-select-option value="1">填写秩序册</a-select-option>
                <a-select-option value="2">人员信息</a-select-option>
                <a-select-option value="3">餐饮预订</a-select-option>
                <a-select-option value="4">接送签证国歌</a-select-option>
                <a-select-option value="5">等待付款</a-select-option>
                <a-select-option value="6">报名成功</a-select-option>
                <a-select-option value="-1">弃权</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="信息审核">
              <r-switch :formData="queryParam" field="shenhe_status" :checkedValue="1" :unCheckedValue="0"
                        checkedChildren="待审核" unCheckedChildren="不限"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="汇款待审核">
              <r-switch :formData="queryParam" field="huikuan_status" :checkedValue="1" :unCheckedValue="0"
                        checkedChildren="待审核" unCheckedChildren="不限"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="开票审核">
              <r-switch :formData="queryParam" field="kaipiao_status" :checkedValue="1" :unCheckedValue="0"
                        checkedChildren="待审核" unCheckedChildren="不限"/>
            </a-form-item>
          </a-col> -->

          <!-- <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="商户订单号">
                <a-input v-model="queryParam.out_trade_no" allowClear placeholder="搜索商户订单号"/>
              </a-form-item>
            </a-col> -->

            <!-- <a-col :md="6" :sm="24">
              <a-form-item label="退款状态">
                <a-select v-model="queryParam.refund_status" placeholder="请选择"
                          allowClear>
                  <a-select-option value="1">未申请</a-select-option>
                  <a-select-option value="2">申请中</a-select-option>
                  <a-select-option value="3">退款成功</a-select-option>
                  <a-select-option value="4">不处理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="线下付款">
                <r-switch :formData="queryParam" field="show_price_offline" :checkedValue="1" :unCheckedValue="0"
                          checkedChildren="有" unCheckedChildren="无"/>
              </a-form-item>
            </a-col> 
          </template>-->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
        <a-button @click="download(1)" style="margin-left: 8px"  >
          酒店订房明细表 <a-icon type="download" />
      </a-button>
      <a-button @click="download(2)" style="margin-left: 8px"  >
        酒店订房汇总表 <a-icon type="download" />
    </a-button>
    <a-button @click="download(3)" style="margin-left: 8px"  >
      接送服务明细表 <a-icon type="download" />
  </a-button> <a-button @click="download(4)" style="margin-left: 8px"  >
    签证信息明细表 <a-icon type="download" />
</a-button>

      <!--            <a-button @click="download(1)" style="margin-left: 8px"  >-->
      <!--                申报裁判名单 <a-icon type="download" />-->
      <!--            </a-button>-->

      <!--            <a-button @click="download(7)" style="margin-left: 8px"  >-->
      <!--                申报教练名单 <a-icon type="download" />-->
      <!--            </a-button>-->

      <!-- <a-button @click="download(2)" style="margin-left: 8px">
        单位联系人导出
        <a-icon type="download"/>
      </a-button>

      <a-button @click="download(3)" style="margin-left: 8px">
        参赛人员身份证统计
        <a-icon type="download"/>
      </a-button>

      <a-button @click="download(4)" style="margin-left: 8px">
        参赛人数统计
        <a-icon type="download"/>
      </a-button>

      <a-button @click="download(5)" style="margin-left: 8px">
        秩序信息表
        <a-icon type="download"/>
      </a-button>

      <a-button @click="download(6)" style="margin-left: 8px">
        缴费信息表
        <a-icon type="download"/>
      </a-button>

      <a-button @click="download(10)" style="margin-left: 8px">
        缴费食宿信息表
        <a-icon type="download"/>
      </a-button>
      <a-button @click="download(8)" style="margin-left: 8px">
        财务汇总表
        <a-icon type="download"/>
      </a-button>
      <a-button @click="download(9)" style="margin-left: 8px">
        发票明细表
        <a-icon type="download"/>
      </a-button> -->
      <!--          <a-button  @click="download(7)">奖杯贴信息表-->
      <!--            <a-icon type="download"/>-->
      <!--          </a-button>-->
      
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{surname}} {{given_name}} {{ record.email }}
            <!-- <br/><span style="color: #999">{{ record.mingcheng }}</span> -->
            <br/>
            用户 {{ record.user_name }} ({{record.phone_pre}} {{ record.lxphone }})
            <br/>
            {{ record.create_time|timeFormat }}
            <br/>
          </div>
      </span>
      <span slot="saiqu" slot-scope="text,record">
        {{ record.saiqu_name }}
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.memberstatus==0">报名草稿</a-tag>
        <a-tag v-if="record.memberstatus==1">填写秩序册</a-tag>
        <a-tag v-if="record.memberstatus==2">人员信息</a-tag>
        <a-tag v-if="record.memberstatus==3">餐饮预订</a-tag>
        <a-tag v-if="record.memberstatus==4">接送签证国歌</a-tag>
        <a-tag color="purple" v-if="record.memberstatus==-1">弃权</a-tag>
        <a-tag v-if="record.memberstatus==5" color="red">等待付款</a-tag>
        <a-tag v-else-if="record.memberstatus==6" color="green">报名成功</a-tag>

        
              <br/>
        <a-tag v-if="record.pay_status==1">未支付</a-tag>
        <a-tag v-else-if="record.pay_status==2" color="blue">已付款</a-tag>
        <br/>
        <a-tag v-if="record.refund_status==2" color="red">申请退款</a-tag>
        <br/>
        <a-tag v-if="record.refund_price>0" color="purple">有退款¥{{ record.refund_price }}</a-tag>

        <a-tag v-if="record.pay_status==1 && record.pay_off_id !=''" color="red">汇款待审核</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a-badge :number-style="{ backgroundColor: '#faad14' }" :count="record.edit_todo_count">
            <a @click="handleEdit(record)">编辑</a>
          </a-badge>
          <a-divider type="vertical"/>
          <a @click="handleOrderEdit(record)">缴费信息</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="applyDelete(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 18 }}"
                  label="报名状态"
                  hasFeedback
              >
                <a-radio-group v-model="formData.memberstatus" button-style="solid">
                  <a-radio-button :value="0">
                    报名草稿
                  </a-radio-button>
                  <a-radio-button :value="1">
                    填写秩序册
                  </a-radio-button>
                  <a-radio-button :value="2">
                    人员信息
                  </a-radio-button>
                  <a-radio-button :value="3">
                    餐饮预订
                  </a-radio-button>
                  <a-radio-button :value="4">
                    接送签证国歌
                  </a-radio-button>
                  <a-radio-button :value="5" :disabled="formData.memberstatus==1">
                    等待付款
                  </a-radio-button>
                  <a-radio-button :value="6" :disabled="formData.memberstatus==1">
                    报名成功
                  </a-radio-button>
                  <a-radio-button :value="-1">
                    弃权
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>联系人</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓" required>
                <a-input v-model="formData.surname" placeholder="请输入姓"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名" required>
                <a-input v-model="formData.given_name" placeholder="请输入名"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="邮箱" required>
                <a-input v-model="formData.email" placeholder="请输入邮箱"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话" required>
                <div class="phone-inline-row">
                  <a-select
                    v-model="formData.phone_pre"
                    placeholder="区号"
                    show-search
                    option-filter-prop="children"
                    class="phone-pre-select"
                  >
                    <a-select-option
                      v-for="opt in phoneCountryOptions"
                      :key="opt.k + '|' + opt.c"
                      :value="phoneOptionValue(opt)"
                    >{{ phoneOptionLabel(opt) }}</a-select-option>
                  </a-select>
                  <a-input v-model="formData.lxphone" placeholder="请输入电话号码" class="phone-num-input"/>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="24" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地址" required>
                <a-textarea v-model="formData.address" :rows="3" placeholder="请输入协会地址"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>人员信息</a-divider>
          <a-table
            :columns="memberColumns"
            :data-source="memberList"
            :pagination="false"
            row-key="rowKey"
            size="small"
            bordered
          >
            <span slot="func" slot-scope="text">{{ memberFuncLabel(text) }}</span>
            <span slot="pass_pdf" slot-scope="text, record">{{ memberFileUploaded(record.pass_pdf) }}</span>
            <span slot="citizenship" slot-scope="text">{{ memberCitizenshipLabel(text) }}</span>
            <span slot="photo" slot-scope="text, record">{{ memberFileUploaded(record.photo) }}</span>
            <span slot="insurance" slot-scope="text, record">{{ memberFileUploaded(record.insurance) }}</span>
          </a-table>

          <a-divider>住宿预订</a-divider>
          <a-table
            :columns="roomBookingColumns"
            :data-source="roomBookingList"
            :pagination="false"
            row-key="rowKey"
            size="small"
            bordered
          >
            <span slot="hotel_room" slot-scope="text, record">
              {{ record.hotel_title }}<br/>{{ record.room_type_name }}
            </span>
            <span slot="check_dates" slot-scope="text, record">
              <template v-if="record.checkin_date || record.checkout_date">
                {{ record.checkin_date || '-' }} ~ {{ record.checkout_date || '-' }}
                <span v-if="record.days">（{{ record.days }} 晚）</span>
              </template>
              <template v-else>-</template>
            </span>
            <span slot="price" slot-scope="text, record">{{ formatUsd(record.price) }}</span>
            <span slot="line_total" slot-scope="text, record">{{ formatUsd(record.line_total) }}</span>
          </a-table>
          <div class="booking-summary">
            <span>总数量: {{ roomBookingTotalQuantity }}</span>
            <span>总价: {{ formatUsd(roomBookingTotalPrice) }}</span>
          </div>

          <a-divider>餐饮预订</a-divider>
          <a-table
            :columns="mealReservationColumns"
            :data-source="mealReservationList"
            :pagination="false"
            row-key="rowKey"
            size="small"
            bordered
          >
            <span slot="price" slot-scope="text, record">{{ formatUsd(record.price) }}</span>
            <span slot="subtotal" slot-scope="text, record">{{ formatUsd(record.subtotal) }}</span>
            <span slot="meal_status" slot-scope="text, record">{{ mealStatusLabel(record.status) }}</span>
          </a-table>
          <div class="booking-summary">
            <span>总数量: {{ mealReservationTotalQuantity }}</span>
            <span>总价: {{ formatUsd(mealReservationTotalPrice) }}</span>
          </div>

          <a-divider>接送服务</a-divider>
          <a-table
            :columns="takeServiceColumns"
            :data-source="takeServiceList"
            :pagination="false"
            row-key="rowKey"
            size="small"
            bordered
          >
            <span slot="station" slot-scope="text, record">
              {{ record.station_name }}
              <template v-if="record.station_address"><br/>{{ record.station_address }}</template>
            </span>
            <span slot="take_status" slot-scope="text, record">{{ takeStatusLabel(record.status) }}</span>
          </a-table>
          <div v-if="takePriceItems.length > 0" class="take-price-breakdown">
            <div v-for="item in takePriceItems" :key="item.station_id" class="take-price-breakdown__row">
              <span class="take-price-breakdown__name">{{ item.station_name }}</span>
              <span class="take-price-breakdown__meta">
                到达合计 {{ item.arrival_count }} · 离港合计 {{ item.departure_count }} ·
                接送计费人数 {{ item.billing_count }} × {{ formatUsd(item.unit_price) }}
              </span>
              <span class="take-price-breakdown__line">站点小计: {{ formatUsd(item.line_total) }}</span>
            </div>
          </div>
          <div class="booking-summary booking-summary--bold">
            <span>总价: {{ formatUsd(takeServiceTotalPrice) }}</span>
          </div>

          <a-divider>签证邀请信息</a-divider>
          <a-table
            :columns="visaColumns"
            :data-source="visaList"
            :pagination="false"
            row-key="rowKey"
            size="small"
            bordered
          >
            <span slot="visa_photo" slot-scope="text, record">{{ fileUploadedLabel(record.photo_uploaded) }}</span>
            <span slot="visa_pass_pdf" slot-scope="text, record">{{ fileUploadedLabel(record.pass_pdf_uploaded) }}</span>
          </a-table>

          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="审批清单" key="1">
              <a-table
                  rowKey="id"
                  :columns="serviceLogColumns"
                  :dataSource="serviceList"
                  :pagination="false"
              >
          <span slot="title1" slot-scope="text,record">
              修改了 {{ record.title }} (<span style="color: #fa8c16; background: #fff7e6;border-color: #ffd591;">
            {{ record.old_name }}
          </span> 修改为
            <span style="color: #fa8c16; background: #fff7e6;border-color: #ffd591;">
              {{ record.new_name }}
            </span>)',
          </span>
                <span slot="status" slot-scope="text,record">
            <a-badge v-if="record.status==1" status="warning" text="待审批"/>
            <a-badge v-else-if="record.status==2" status="success" text="已完成"/>
            <a-badge v-else-if="record.status==3" status="error" text="拒绝"/>
            <a-badge v-else-if="record.status==4" status="default" text="撤销"/>
          </span>
                <span slot="complete_time" slot-scope="text,record">
            提交 {{ record.create_time|timeFormat }}<br/>
            <em v-if="record.complete_time>0">完成 {{ record.complete_time|timeFormat }}</em>
          </span>
                <span slot="actions" slot-scope="text,record,index">
                  <a-popconfirm title="确定同意本操作吗?确定后不恢复" @confirm="handleEditDo(record.id,2)" okText="确定"
                                cancelText="取消">
              <a v-if="record.status==1">同意</a>
                    </a-popconfirm>
    <a-divider type="vertical"/>
                  <a-popconfirm title="确定同意本操作吗?确定后不恢复" @confirm="handleEditDo(record.id,3)" okText="确定"
                                cancelText="取消">
              <a v-if="record.status==1">拒绝</a>
                    </a-popconfirm>
          </span>
              </a-table>

            </a-tab-pane>
            <a-tab-pane tab="操作日志" key="2">
              <div style="padding: 20px">
                <a-timeline>
                  <a-timeline-item v-for="log in formData.loglist" :key="log.id">
                    {{ log.create_time|timeFormat }}
                    <b>{{ log.user_name }}</b>
                    {{ log.title }}
                    <span v-if="log.note" class="gray">备注:{{ log.note }}</span>
                  </a-timeline-item>
                </a-timeline>
              </div>
            </a-tab-pane>
          </a-tabs>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        title="操作"
        :width="1200"
        :maskClosable="false"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="orderVisible"
        @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <!-- <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
              >
                {{ orderFormData.danwei }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="队伍名称"
                  hasFeedback
              >
                {{ orderFormData.mingcheng }}
              </a-form-item>
            </a-col>
          </a-row> -->

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="赛事服务费"
                  hasFeedback
              >
                <a-input :disabled="true" v-model="orderFormData.memberprice" allowClear placeholder="赛事服务费"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="应付"
                  hasFeedback
              >
                <a-input style="width: 70%; margin-right: 10px" :disabled="true" v-model="orderFormData.pay_price"
                         allowClear placeholder="应付金额"/>
                <a-button @click="refreshPrice">刷新</a-button>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="食宿费用"
                  hasFeedback
              >
                {{ orderFormData.shisuprice }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上支付时间"
                  hasFeedback
              >
                {{ orderFormData.pay_time_str }}
                <br/> {{orderFormData.pay_type_name}} {{orderFormData.pay_company}}
                {{orderFormData.out_trade_no}} 
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <!-- <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="补缴食宿费"
                  hasFeedback
              >
                <a-input v-model="orderFormData.diyprice" type="number" allowClear placeholder="食宿自定义调价"/>
                食宿费用小记：
                {{ orderFormData.shisu_total}}
              </a-form-item> -->
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="网银单号"
                  hasFeedback
              >
                <a-input v-model="orderFormData.pay_code" allowClear placeholder="网银单号"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线下实收"
                  hasFeedback
              >
                <a-input v-model="orderFormData.payed_price_offline" allowClear placeholder="线下实收"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上实收"
                  hasFeedback
              >
                {{ orderFormData.payed_price }} + {{orderFormData.bu_price}}(线上补缴) = {{orderFormData.payed_price_online }}
                <br/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="支付状态"
                  hasFeedback
              >
                <a-radio-group v-model="orderFormData.status" button-style="solid">
                  <a-radio-button :value="1">
                    未支付
                  </a-radio-button>
                  <a-radio-button :value="2">
                    支付成功
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>


            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="退款金额"
                  hasFeedback
              >
             ¥{{orderFormData.refund_price_all}} (含线下退款¥{{orderFormData.refund_price_off}})
                <br/>
                <div>
                  <a-tag color="red" v-if='orderFormData.refund_apply_comment'> 
                    {{ orderFormData.refund_apply_comment }}
                  </a-tag>
                </div>
                <a-button v-show="orderFormData.is_caiwu_admin" @click="onRefund">在线退款</a-button>
                <a-button v-show="orderFormData.is_caiwu_admin&&orderFormData.refund_status==2" @click="onRefundRefuse">
                  不处理
                </a-button>
                <a-button v-show="!orderFormData.is_caiwu_admin" style="margin-right: 10px" @click="onRefundApply(1)">申请退款（在线支付）</a-button>
                <a-button v-show="!orderFormData.is_caiwu_admin" style="margin-right: 10px" @click="onRefundApply(2)">申请退款（线下付款）</a-button>
                <a-button @click="onSubjectApply">项目管理</a-button>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线下退款金额"
                  hasFeedback 
              >
                <a-input v-model="orderFormData.refund_price_off" allowClear placeholder="线下退款金额"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24"> 
            </a-col>

          </a-row>

          <a-row>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="管理员备注"
                  hasFeedback
              >
                <a-textarea v-model="orderFormData.adminnote" placeholder="" auto-size/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="支付凭证"
                  hasFeedback
              >
                <pic-uploader
                    :file-list="orderFormData.pics"
                />
              </a-form-item>
            </a-col>

          </a-row>


          <a-row>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线下付款订单号"
                  hasFeedback
              >
                <a-input v-model="orderFormData.pay_off_id" allowClear placeholder="线下付款订单号"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24"> 
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线下付款时间"
                  hasFeedback
              >
                <a-input v-model="orderFormData.pay_off_date" allowClear placeholder="线下付款时间"/>
              </a-form-item>
            </a-col>

          </a-row>

        </a-form>


        <!-- <a-divider>费用补缴
          <a-popconfirm okText="确定" cancelText="取消" @confirm="setBuPrice()">
            <a-icon type="plus-circle"/>
            <template slot="title">
              请输入需要补缴的金额 <br/>
              <a-input
                  style="width: 200px; margin: 10px 0 0 0"
                  type="number"
                  v-model="buPrice"
                  placeholder="输入金额"/>
                  <br/>
              <a-textarea
                  style="width: 200px; margin: 10px 0 0 0"
                  type="number"
                  v-model="buNote"
                  placeholder="输入备注信息"/>
            </template>
          </a-popconfirm>
        </a-divider> -->

        <a-table v-if="false" :columns="orderBujiaoColumns" :data-source="orderFormData.bu_list" :pagination="false">
                    <span slot="price" slot-scope="text,record">
                    <template>
                        {{ record.pay_price }}元 <span v-show="record.refund_price >0">(已退款{{record.refund_price}}元)</span>
                        <br/><span style="margin-right:20px" v-if="record.admin_user_name">操作人：{{record.admin_user_name}}</span>
                        <span v-if="record.adminnote">备注：{{record.adminnote}}</span> 
                    </template>
                    </span>
          <span slot="status" slot-scope="text,record">
                    <template>
                      <div  v-if="record.refund_status==3">
                        <a-badge status="success" text="退款成功"/>
                      </div>
                      <div v-else>
                        <a-badge v-if="record.status==1" status="warning" text="待支付"/>
                        <a-badge v-else-if="record.status==2" status="success" text="已支付"/>
                        <a-badge v-else-if="record.status==3" status="error" text="支付失败"/>
                      </div>

                    </template>
          </span>

          <span slot="action" slot-scope="text,record">
                        <template>

                <div>
                  <a-tag color="red" v-if='record.refund_apply_comment'> 
                    {{ record.refund_apply_comment }}
                  </a-tag>
                </div>
                <a-button v-show="!orderFormData.is_caiwu_admin" style="margin-right: 10px" @click="onRefundApply(1,record.id)">申请退款</a-button>
                <a-button v-show="orderFormData.is_caiwu_admin&&record.refund_status==2" @click="onRefundRefuse(record.id)">
                  不处理
                </a-button>
        <a-button v-show="orderFormData.is_caiwu_admin" style="margin-right: 10px" @click="onBuRefund(record)">在线退款</a-button>
       <!-- <a-button @click="onBuRefund(record)" style="margin-right: 10px">在线退款</a-button> -->
          <a-popconfirm v-show="record.status==1" title="删除后不可恢复,确定删除吗?" @confirm="buOrderDelete(record)" okText="确定"
                        cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
                        </template>
                    </span>

        </a-table>



        <!-- <a-divider>退款明细（2023年7月15日之后的退款申请记录）
        </a-divider> -->


        <a-table v-if="false" :columns="orderRefundColumns" :data-source="orderFormData.refund_list" :pagination="false">
                    <span slot="price" slot-scope="text,record">
                    <template>
                        申请退款{{ record.price }}元
                        <br/>类型：<span v-if="record.type==1">线上</span><span v-else>线下</span>
                        <div  v-if="record.type==2" >
                          账户名：{{record.account}}<br/>
                          卡号：{{record.card}}<br/>
                          开户行：{{record.bank}}
                        </div>
                        经办人：{{record.user_name}}
                        <br/>
                        <span >申请理由：{{record.apply_comment}}</span> <br/>
                        {{record.create_time_str}}
                    </template>
                    </span>
          <span slot="status" slot-scope="text,record">
                    <template>
                      <div  v-if="record.refund_status==3">
                        <a-badge status="success" text="退款成功"/>
                      </div>
                      <div v-else>
                        <a-badge v-if="record.refund_status==2" status="warning" text="申请退款"/> 
                        <a-badge v-else-if="record.refund_status==4" status="error" text="不处理"/> 
                      </div>
                      处理时间 {{record.do_time_str}}
                    </template>
          </span>

          <span slot="action" slot-scope="text,record">
                        <template>

          <a-button   @click="onRefundDownload(record.id)">
                          下载表格
                        </a-button>
          <a-button v-show="orderFormData.is_caiwu_admin&&record.refund_status==2" @click="onRefundRefuse2023(record.id)">
                          不处理
                        </a-button>
                        <a-popconfirm v-show="orderFormData.is_caiwu_admin&&record.refund_status==2&&record.type==2"  @confirm="onRefund2023(record.id)" okText="确定">
                <a-button  style="margin-right: 10px"  >线下退款完成（需要线下手动退款后操作）</a-button>
                <template slot="title">
                        <a-input v-model="pay_password" 
                                    placeholder="请输入密码"/><br/>
                                    不可恢复,确定操作吗?
                      </template>
                        </a-popconfirm>
                <a-popconfirm v-show="orderFormData.is_caiwu_admin&&record.refund_status==2&&record.type==1"   @confirm="onRefund2023(record.id)" okText="确定">
                <a-button  style="margin-right: 10px" >在线退款（在线原路退回到用户银行卡微信支付宝）</a-button>
                      <template slot="title">
                        <a-input v-model="pay_password" 
                                    placeholder="请输入密码"/><br/>
                                    不可恢复,确定操作吗?
                      </template>
                  </a-popconfirm> 
                        </template>
                    </span>

        </a-table>


      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleOrderCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOrderOk">保存</a-button>
      </template>
    </a-modal>
    <a-modal
        :maskClosable="false" v-model="refundVisible"
        title="操作"
        :width="800"
        @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">

        <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="退款金额"
            :extra="'已退款'+orderFormData.refund_price+'元，还可退款'+(orderFormData.payed_price-orderFormData.refund_price)+'元'"
            hasFeedback
        >
          <a-input v-model="refund_price" placeholder=""/>
        </a-form-item>

        <a-form-item
            label="理由"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input
              v-model="refund_comment"
              placeholder="请输入理由"/>
        </a-form-item>

        <a-form-item
            label="密码"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input
              type="password"
              v-model="refund_mima"
              placeholder="请输入密码"/>
        </a-form-item>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleRefundCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleRefundOk">确定</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false" v-model="refundBuVisible"
        title="补交费用退款"
        :width="800"
        @ok="handleBuRefundOk"
    >
      <a-spin :spinning="saveLoading">

        <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="退款金额"
            :extra="'已退款'+orderBuFormData.refund_price+'元，还可退款'+(orderBuFormData.pay_price-orderBuFormData.refund_price)+'元'"
            hasFeedback
        >
          <a-input v-model="refund_price" placeholder=""/>
        </a-form-item>

        <a-form-item
            label="理由"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input
              v-model="refund_comment"
              placeholder="请输入理由"/>
        </a-form-item>

        <a-form-item
            label="密码"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input
              type="password"
              v-model="refund_mima"
              placeholder="请输入密码"/>
        </a-form-item>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleOrderBuCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleBuRefundOk">确定</a-button>
      </template>
    </a-modal>

    <a-modal
        v-model="refundApplyVisible"
        title="申请退款"
        :width="800"
        @ok="handleRefundApplyOk"
    >
      <a-spin :spinning="saveLoading">

        <a-form-item
            label="退款金额"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input
              type="number"
              v-model="refund_apply_price"
              placeholder="请输入申请退款金额"/>
        </a-form-item>
        <a-form-item
            v-if="refund_apply_type==2"
            label="账户名"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input 
              v-model="refund_apply_account"
              placeholder="请输入账户名"/>
        </a-form-item>

        <a-form-item
            v-if="refund_apply_type==2"
            label="卡号"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input 
              v-model="refund_apply_card"
              placeholder="请输入卡号"/>
        </a-form-item>


        <a-form-item
            v-if="refund_apply_type==2"
            label="开户行"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-input 
              v-model="refund_apply_bank"
              placeholder="请输入开户行"/>
        </a-form-item>

        <a-form-item
            label="备注"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <a-textarea
              v-model="refund_apply_comment"
              placeholder="请输入申请退款理由/单号/时间等"/>
        </a-form-item>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleRefundApplyCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleRefundApplyOk">确定</a-button>
      </template>
    </a-modal>


    <a-modal title="新增开票" :width="1000" v-model="kaipiaoVisible">
      <a-spin :spinning="saveLoading">
        <a-form :form="fapiaoForm">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="抬头"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_taitou',
          {rules: [{ required: true, message: '请输入抬头' }]}
        ]"
                         placeholder="请输入抬头"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="税号"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_shuihao',
          {rules: [{ required: true, message: '请输入税号' }]}
        ]" placeholder="请输入税号"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="图片链接"
                  hasFeedback
              >
                <a-input v-decorator="[
          'pic_url',
          {rules: [{ required: true, message: '请输入图片链接' }]}
        ]"
                         placeholder="请输入图片链接"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="PDF文件链接"
                  hasFeedback
              >
                <a-input v-decorator="[
          'pdf_url',
          {rules: [{ required: true, message: '请输入PDF链接' }]}
        ]"
                         placeholder="请输入PDF文件链接"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票号码"
                  hasFeedback
              >
                <a-input v-decorator="[
          'invoiceNum',
          {rules: [{ required: false, message: '请输入发票号码' }]}
        ]"
                         placeholder="请输入发票号码"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票代码"
                  hasFeedback
              >
                <a-input v-decorator="[
          'invoiceCode',
          {rules: [{ required: false, message: '请输入发票代码' }]}
        ]"
                         placeholder="请输入发票代码"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票备注"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'fapiao_beizhu',
          {rules: [{ required: false, message: '请输入发票备注' }]}
        ]"
                         placeholder="请输入发票备注"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收邮箱"
                  hasFeedback
              >
                <a-input   v-decorator="[
          'fapiao_email',
          {rules: [{ required: false, message: '请输入接收邮箱' }]}
        ]"  
                         placeholder="请输入接收邮箱"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收手机"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'fapiao_phone',
          {rules: [{ required: false, message: '请输入接收手机' }]}
        ]"   
                         placeholder="请输入接收手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="kaipiaoVisible = false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="kaipiaoApplyOk">确定</a-button>
      </template>
    </a-modal>


    <a-modal title="申请开票" :width="1000" v-model="kaipiaoShenqingVisible">
      <a-spin :spinning="saveLoading">
        <a-form :form="fapiaoShenqingForm">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="抬头"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_taitou',
          {rules: [{ required: true, message: '请输入抬头' }]}
        ]"
                         placeholder="请输入抬头"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="税号"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_shuihao',
          {rules: [{ required: true, message: '请输入税号' }]}
        ]" placeholder="请输入税号"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="地址"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_address',
          {rules: [{ required: false, message: '（非必填）发票购买方地址' }]}
        ]"
                         placeholder="（非必填）发票购买方地址"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="电话"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_tel',
          {rules: [{ required: false, message: '（非必填）发票购买方电话' }]}
        ]"
                         placeholder="请输入（非必填）发票购买方电话"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="开户行及账号"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_account',
          {rules: [{ required: false, message: '请输入（非必填）发票购买方开户行及账号' }]}
        ]"
                         placeholder="请输入（非必填）发票购买方开户行及账号"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="备注"
                  hasFeedback
              >
                <a-input v-decorator="[
          'fapiao_beizhu',
          {rules: [{ required: false, message: '请输入备注' }]}
        ]"
                         placeholder="请输入备注"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24"> 
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收手机"
                  hasFeedback
              >
                <a-input  
                v-decorator="[
          'fapiao_phone',
          {rules: [{ required: false, message: '请输入接收手机' }]}
        ]" 
                         placeholder="请输入接收手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="接收邮箱"
                  hasFeedback
              >
                <a-input 
                v-decorator="[
          'fapiao_email',
          {rules: [{ required: false, message: '请输入接收邮箱' }]}
        ]" 
                         placeholder="请输入接收邮箱"/>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="发票总金额"
                  hasFeedback
              >{{
                formFapiaoShenqingData.total
              }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>
        </a-form>


          <a-divider>发票明细 
          </a-divider>

          <a-table :columns="fapiaoItemColumns" :data-source="formFapiaoShenqingData.list" :pagination="false">
            <span slot="num" slot-scope="text,record,index">
              <template>
                <p v-if="index==0">
                  {{record.num}}
                </p>
                <p v-else>
                  <a-input-number v-model="record.num" :min="0" @change="fapiaoMxNumChange" :max="record.num_max" />
                </p>
                  
              </template>
            </span>
              <span slot="total" slot-scope="text,record,index">
              <template>
                <p v-if="index==0">
                  {{record.total}}
                </p>
                <p v-else >
                    <a-input-number v-model="record.total" :min="0"  @change="fapiaoMxTotalChange" :max="record.max" />
                </p>
              </template>
            </span>

          </a-table>



      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="kaipiaoShenqingVisible = false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="kaipiaoShenqingApplyOk">确定</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量导入人员"
        v-model="taskInfoShow"
    >
      <a-badge status="success" :text="'校验成功 '+(taskInfo.scount)"/>
      <a-divider type="vertical"/>
      <a-badge status="error" :text="'校验失败 '+(taskInfo.fcount)"/>
      <a-divider type="vertical"/>
      <a-badge status="processing" :text="'总数 '+(taskInfo.members.length) "/>
      <p v-show="taskInfo.errors.length>0" >存在以下错误，请修正后重新上传 </p>
      <div style="height: 300px; overflow:scroll;">
        <p v-for="error in taskInfo.errors">{{error}}</p>
      </div>
      <a-progress :percent="taskInfo.percent"/>
    </a-modal>

  </a-card>
</template>

<style scoped>
.phone-inline-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}
.phone-pre-select {
  flex: 0 0 120px;
  width: 120px;
  margin-right: 8px;
}
.phone-num-input {
  flex: 1;
  min-width: 0;
}
.booking-summary {
  margin: 8px 0 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}
.booking-summary--bold {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.take-price-breakdown {
  margin: 8px 0 12px;
  padding: 10px 12px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
}
.take-price-breakdown__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding: 6px 0;
}
.take-price-breakdown__row + .take-price-breakdown__row {
  border-top: 1px dashed #e8e8e8;
}
.take-price-breakdown__name {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  min-width: 100px;
}
.take-price-breakdown__line {
  margin-left: auto;
  color: rgba(0, 0, 0, 0.85);
}
</style>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import JiaolianPicker from '@/components/JiaolianPicker/'
import CaipanPicker from '@/components/CaipanPicker/'
import RSwitch from '@/components/RSwitch/'
import XLSX from 'xlsx'
import areaOptions from '@/utils/area'
import { PHONE_COUNTRY_OPTIONS } from '@/utils/phoneCountryOptions'
import { MEMBER_FUNCTION_OPTIONS } from '@/utils/memberFunctionOptions'

const LEGACY_CITIZENSHIP = {
  CHINESE: '中国',
  AMERICAN: '美国',
  BRITISH: '英国',
};

const createEmptyMember = () => ({
  rowKey: `m-${Date.now()}-${Math.random()}`,
  func: 'Gymnast',
  full_name: '',
  birth_date: '',
  fig_license: '',
  passport_number: '',
  pass_pdf: [],
  pass_expiry_date: '',
  citizenship: '中国',
  photo: [],
  insurance: [],
});

function normalizeCitizenshipKey(val) {
  if (val == null || val === '') {
    return '中国';
  }
  const s = String(val);
  if (LEGACY_CITIZENSHIP[s]) {
    return LEGACY_CITIZENSHIP[s];
  }
  if (PHONE_COUNTRY_OPTIONS.some((o) => o.k === s)) {
    return s;
  }
  return null;
}

function normalizeMemberRowFromApi(item, index) {
  const member = createEmptyMember();
  member.rowKey = item.id ? `id-${item.id}` : `row-${index}`;
  member.func = item.func || 'Gymnast';
  member.full_name = item.full_name || '';
  member.birth_date = item.birth_date || '';
  member.fig_license = item.fig_license || '';
  member.passport_number = item.passport_number || '';
  member.pass_pdf = Array.isArray(item.pass_pdf) ? item.pass_pdf : [];
  member.pass_expiry_date = item.pass_expiry_date || '';
  const ck = normalizeCitizenshipKey(item.citizenship);
  member.citizenship = ck !== null ? ck : (item.citizenship != null && item.citizenship !== '' ? String(item.citizenship) : '中国');
  member.photo = Array.isArray(item.photo) ? item.photo : [];
  member.insurance = Array.isArray(item.insurance) ? item.insurance : [];
  member.id = item.id || 0;
  return member;
}
import moment from 'moment'
import setting from '@/config/setting'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

import {
  getApplyList,
  getApplyDetail,
  editApply,
  applyDelete,
  sjsqOptions,
  getApplyOrderDetail,
  editApplyOrder,
  refreshOrder,
  editDo,
  orderRefund,
  orderRefund2023,
  orderBuRefund,
  orderRefundApply,
  orderRefundRefuse,
  orderRefundRefuse2023,
  setBuPrice,
  setBuNote,
  buOrderDelete,
  fapiaoImport,
  getKaipiaoItemList,
  fapiaoShenqingApply,
  fapiaoApply,
  checkBaomingInfoOk,
  baomingImport
} from '@/api/sai'
import {fapiaoDelete, fapiaoZuofei, refreshFapiao,kaipiao} from '@/api/fapiao'

export default {
  name: 'KaojiApplyList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    CaipanPicker,
    JiaolianPicker,
    RSwitch
  },
  data() {
    return {
      areaOptions,
      buPrice: '',
      buNote: '',
      visible: false,
      taskInfoShow: false,
      kaipiaoVisible: false,
      kaipiaoShenqingVisible: false,
      roomBookingList: [],
      roomBookingTotalQuantity: 0,
      roomBookingTotalPrice: 0,
      mealReservationList: [],
      mealReservationTotalQuantity: 0,
      mealReservationTotalPrice: 0,
      takeServiceList: [],
      takePriceItems: [],
      takeServiceTotalPrice: 0,
      visaList: [],
      refundVisible: false,
      refundBuVisible: false,
      refundApplyVisible: false,
      refund_price: '',
      refund_apply_price: '',
      refund_apply_type: '',
      refund_apply_card: '',
      refund_apply_account: '',
      refund_apply_bank: '',
      refund_apply_comment: '',
      refund_order_bu_id: '',
      refund_comment: '',
      refund_mima: '',
      orderVisible: false,
      saveLoading: false,
      jiaolianPickerShow: false,
      caipanPickerShow: false,
      phoneCountryOptions: PHONE_COUNTRY_OPTIONS,
      memberList: [],
      memberColumns: [
        { title: '职能', dataIndex: 'func', scopedSlots: { customRender: 'func' }, width: 160 },
        { title: '全名', dataIndex: 'full_name', width: 120 },
        { title: '出生日期', dataIndex: 'birth_date', width: 110 },
        { title: 'FIG执照', dataIndex: 'fig_license', width: 100 },
        { title: '护照号码', dataIndex: 'passport_number', width: 120 },
        { title: '护照PDF', dataIndex: 'pass_pdf', scopedSlots: { customRender: 'pass_pdf' }, width: 80 },
        { title: '护照到期日', dataIndex: 'pass_expiry_date', width: 110 },
        { title: '国籍', dataIndex: 'citizenship', scopedSlots: { customRender: 'citizenship' }, width: 90 },
        { title: '照片', dataIndex: 'photo', scopedSlots: { customRender: 'photo' }, width: 70 },
        { title: '保险', dataIndex: 'insurance', scopedSlots: { customRender: 'insurance' }, width: 70 },
      ],
      sjsqOptions: [],
      pay_password:'',
      orderFormData: {
        bu_list: []
      },
      orderBuFormData: {

      },
      formData: {
        id: 0,
        danwei: '',
        mingcheng: '',
        mingcheng_end: '',
        datetitle_moment: null,
        datetitle: '',
        heying: [],
        jiaolian: [],
        caipan: [],
        subjectlist: [],
        loglist: [],
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      fapiaoForm: this.$form.createForm(this),
      fapiaoShenqingForm: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { 
        keywords: '',
        shenhe_status: 0,
        kaipiao_status: 0,
        is_jizan:2,
        huikuan_status: 0,
        baoming_id: 0,
        show_price_offline: 0,
        sjsq: [],
      },
      serviceLogColumns: [
        {
          title: '说明',
          dataIndex: 'title',
          width: 400,
          scopedSlots: {customRender: 'title1'}
        },
        {
          title: '状态',
          dataIndex: 'admin_status',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: '完成时间',
          dataIndex: 'complete_time',
          scopedSlots: {customRender: 'complete_time'}
        },
        {
          title: '申请人',
          dataIndex: 'apply_user_name',
        },
        {
          title: '操作',
          dataIndex: 'id',
          scopedSlots: {customRender: 'actions'}
        }
      ],
      serviceList: [
        {
          id: 1,
          step: 0,
          description: '',
          title: '修改了队伍名称(<span style="color: #fa8c16; background: #fff7e6;border-color: #ffd591;">小星星啦啦队</span> 修改为 <span style="color: #fa8c16; background: #fff7e6;border-color: #ffd591;">小天使啦啦队</span>)',
          admin_status: 1,
          admin_user_name: '宋巨报',
          complete_time: '',
          plan_time: '2020-12-12',
        },
        {
          id: 2,
          step: 0,
          title: '修改了领队姓名(<span style="color: #fa8c16; background: #fff7e6;border-color: #ffd591;">李美</span> 修改为 <span style="color: #fa8c16; background: #fff7e6;border-color: #ffd591;">李红</span>)',
          admin_status: 3,
          description: '',
          admin_user_name: '宋巨报',
          complete_time: '2020-12-17',
          plan_time: '2020-12-12',
        },],
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '报名信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        {
          title: '赛区',
          dataIndex: 'saiqu',
          scopedSlots: {
            customRender: 'saiqu' +
                ''
          },
        },
        {
          title: '进度',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 220,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 表头
      subjectColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '项目信息',
          dataIndex: 'subject_name',
        },
      ],
      roomBookingColumns: [
        { title: '序号', dataIndex: 'index', width: 56 },
        { title: '酒店房型', dataIndex: 'hotel_room', scopedSlots: { customRender: 'hotel_room' } },
        { title: '入住退房', dataIndex: 'check_dates', scopedSlots: { customRender: 'check_dates' } },
        { title: '数量', dataIndex: 'quantity', width: 72 },
        { title: '单价', dataIndex: 'price', width: 110, scopedSlots: { customRender: 'price' } },
        { title: '小计', dataIndex: 'line_total', width: 110, scopedSlots: { customRender: 'line_total' } },
      ],
      mealReservationColumns: [
        { title: '场地', dataIndex: 'venue_title' },
        { title: '套餐类型', dataIndex: 'meal_set_name' },
        { title: '数量', dataIndex: 'quantity', width: 72 },
        { title: '价格', dataIndex: 'price', width: 110, scopedSlots: { customRender: 'price' } },
        { title: '小计', dataIndex: 'subtotal', width: 110, scopedSlots: { customRender: 'subtotal' } },
        { title: '状态', dataIndex: 'status', width: 88, scopedSlots: { customRender: 'meal_status' } },
      ],
      takeServiceColumns: [
        { title: '行程类型', dataIndex: 'direction_label', width: 88 },
        { title: '出行日期', dataIndex: 'date', width: 110 },
        { title: '航班车次号', dataIndex: 'transcode', width: 120 },
        { title: '机场站点', dataIndex: 'station_name', scopedSlots: { customRender: 'station' } },
        { title: '人数', dataIndex: 'member_count', width: 64 },
        { title: '行李件数', dataIndex: 'luggage_count', width: 80 },
        { title: '状态', dataIndex: 'status', width: 72, scopedSlots: { customRender: 'take_status' } },
      ],
      visaColumns: [
        { title: '姓', dataIndex: 'surname', width: 90 },
        { title: '名', dataIndex: 'given_name', width: 100 },
        { title: '性别', dataIndex: 'sex_label', width: 56 },
        { title: '护照号码', dataIndex: 'passport_number', width: 120 },
        { title: '护照到期日', dataIndex: 'pass_expiry_date', width: 110 },
        { title: '申请城市', dataIndex: 'city_to_apply', width: 100 },
        { title: '抵达日期', dataIndex: 'arrival_date', width: 100 },
        { title: '离境日期', dataIndex: 'departure_date', width: 100 },
        { title: '照片', dataIndex: 'photo_uploaded', width: 72, scopedSlots: { customRender: 'visa_photo' } },
        { title: '护照PDF', dataIndex: 'pass_pdf_uploaded', width: 80, scopedSlots: { customRender: 'visa_pass_pdf' } },
      ],
      formFapiaoShenqingData: {
        id: 0, 
        total:0,
        list: [],
      },
      fapiaoItemColumns:[
        {
          title: '名称',
          dataIndex: 'name', 
        },
        {
          title: '单价',
          dataIndex: 'price', 
        },
        {
          title: '数量',
          dataIndex: 'num', 
          scopedSlots: {customRender: 'num'},
        },
        {
          title: '小记',
          dataIndex: 'total',
          scopedSlots: {customRender: 'total'},
        },

      ],
      orderBujiaoColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '金额',
          dataIndex: 'price',
          scopedSlots: {customRender: 'price'},
        },
        {
          title: '商户订单号',
          dataIndex: 'out_trade_no',
          scopedSlots: {customRender: 'out_trade_no'},
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],

      orderRefundColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '金额',
          dataIndex: 'price',
          scopedSlots: {customRender: 'price'},
        }, 
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        this.queryParam.baoming_id = this.$route.query.baoming_id
        this.queryParam = Object.assign(this.queryParam, parameter);
        return getApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      },
      taskInfo: {
        members: [],
        errors: [],
        currentIndex: 0,
        scount: 0,
        fcount: 0,
        percent: 0,
        doing: false,
      },
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
    that.getSjsqOptions();
  },
  methods: {
    moment,
    getSjsqOptions() {
      let that = this;
      sjsqOptions({
        is_jizan:2
      }).then(res => {
        that.sjsqOptions = res.data;
      });
    },
    handleCancel() {
      this.visible = false
    },
    handleOrderCancel() {
      this.orderVisible = false
    },
    handleOrderBuCancel() {
      this.orderBuVisible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    onFaipiaoApplyShow() {
      let self = this
      self.kaipiaoVisible = true

      // 赋值
      setTimeout(function () {
        self.fapiaoForm.setFieldsValue({...self.formData})
      }, 200)
    },

    onFaipiaoShenqingApplyShow() {
      let self = this

      getKaipiaoItemList({
        id:this.formData.id
      })
      .then(res => {
        console.log('res');
        self.formFapiaoShenqingData.list =  res.data.list
        self.formFapiaoShenqingData.list.map(item =>{
          this.$set(item,'num_max',item.num); 
        })
      }) 


      self.kaipiaoShenqingVisible = true

      // 赋值
      setTimeout(function () {
        self.fapiaoShenqingForm.setFieldsValue({...self.formData})
      }, 200)
    },

    beforeUpload(file) {
      let that = this
      let formdata = new FormData()
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata)

      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log('this.xlsxJson', tabJson);
          let userList = [];
          tabJson[0].sheet.map((item, index) => {
            if (index > 0) {
              // userList.push({
              //   saiqu: item.赛事报名人员信息导入模板,
              //   danwei: item.__EMPTY,
              //   mingcheng: item.__EMPTY_1,
              //   lingdu: item.__EMPTY_2 || '',
              //   lianxi: item.__EMPTY_3 || '',
              //   member: item.__EMPTY_4 || '',
              //   subject: item.__EMPTY_5 || '',
              //   subject_name: item.__EMPTY_6 || '',
              //   subject_member: item.__EMPTY_7 || '',
              // });

              userList.push({
                saiqu: item.赛事报名人员信息导入模板,
                danwei: item.__EMPTY,
                mingcheng: item.__EMPTY_1,
                subject_name: item.__EMPTY_2 || '',
                lingdu: item.__EMPTY_3 || '',
                jiaolian: item.__EMPTY_4 || '',
                caipan: item.__EMPTY_5 || '',
                yundongyuan: item.__EMPTY_6 || '',
                yundongyuan_tibu: item.__EMPTY_7 || '',
                subjectId: item.__EMPTY_8 || '',
              });
            }
          })

          console.log('userList', userList);
          // return


          that.taskInfo = {
            members: userList,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            errors: [],
            doing: true,
          }
          that.taskInfoShow = true;
          that.doTask(that.taskInfo);
        }
      });

      /*
      expressImport(formdata)
        .then(res => {
          that.$message.success('上传成功')
          that.$refs.table.refresh(true)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })*/
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        reader.onload = function (e) {
          const data = e.target.result
          this.wb = XLSX.read(data, {
            type: 'binary'
          })
          const result = []
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            })
          })
          resolve(result)
        }
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file) // 传统input方法
      })
    },

    doTask(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.members.length) {
        taskInfo.doing = false;
        //结束
        console.log('taskInfo.members',taskInfo)
        if (taskInfo.fcount == 0) {
          baomingImport({
            list: JSON.stringify(taskInfo.members)
            // peixun_id: that.queryParam.sjsq[1]
          }).then(res => {
            that.taskInfoShow = false;
            that.$message.success('上传成功')
            that.$refs.table.refresh(true)
          });
        }
        return false;
      }
      checkBaomingInfoOk({
        saiqu: taskInfo.members[taskInfo.currentIndex].saiqu,
        danwei: taskInfo.members[taskInfo.currentIndex].danwei,
      }).then(res => {
        if (res.data.length > 0) {
          taskInfo.fcount++;
          taskInfo.errors = taskInfo.errors.concat(res.data);
          taskInfo.currentIndex++;
        } else {
          taskInfo.scount++;
          taskInfo.currentIndex++;
          console.log(taskInfo.currentIndex);
          if (taskInfo.currentIndex == (taskInfo.members.length)) {
          }
        }
        taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.members.length) * 100).toFixed(1);
        that.doTask(taskInfo)
      }).catch(err => {
        taskInfo.fcount++;
        taskInfo.currentIndex++;
        taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.members.length) * 100).toFixed(1);
        that.doTask(taskInfo)
      });
    },


    kaipiaoApplyOk(e) {
      let self = this;
      e.preventDefault();

      this.fapiaoForm.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          fapiaoApply({
            id: self.formData.id,
            fapiao_taitou: values.fapiao_taitou,
            fapiao_shuihao: values.fapiao_shuihao,
            pic_url: values.pic_url,
            pdf_url: values.pdf_url,
            invoiceNum: values.invoiceNum,
            invoiceCode: values.invoiceCode,
            fapiao_beizhu: values.fapiao_beizhu,
            fapiao_email: values.fapiao_email,
            fapiao_phone: values.fapiao_phone,
          }).then(res => {
            self.$message.success('新增成功')
            self.handleEdit(self.formData)
            self.saveLoading = false
            self.kaipiaoVisible = false
          }).catch(err => {
            self.$message.error(err.data.msg)
            self.saveLoading = false
          })
        }
      })

    },


    kaipiaoShenqingApplyOk(e) {
      let self = this;
      e.preventDefault();

      this.fapiaoShenqingForm.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values) 
          self.saveLoading = true;
          fapiaoShenqingApply({
            id: self.formData.id,
            fapiao_taitou: values.fapiao_taitou,
            fapiao_shuihao: values.fapiao_shuihao,
            fapiao_address: values.fapiao_address,
            fapiao_tel: values.fapiao_tel,
            fapiao_account: values.fapiao_account,
            fapiao_beizhu: values.fapiao_beizhu,
            fapiao_email: values.fapiao_email,
            fapiao_phone: values.fapiao_phone,
            list: self.formFapiaoShenqingData.list,
          }).then(res => {
            self.$message.success('申请提交成功')
            self.handleEdit(self.formData)
            self.saveLoading = false
            self.kaipiaoShenqingVisible = false
          }).catch(err => {
            self.$message.error(err.data.msg)
            self.saveLoading = false
          })
        }
      })

    },

    jiaolianRemove(index) {
      console.log('jiaolianRemove', index);
      this.formData.jiaolian.splice(index, 1);
      this.jiaolianPickerShow = false;
    },
    onJiaolianAdd(value) {
      console.log('onJiaolianAdd', value);
      let exist = this.formData.jiaolian.filter(item => {
        return item.num == value.num
      });
      if (exist.length > 0) {
        this.jiaolianPickerShow = false;
        return;
      }
      this.formData.jiaolian.push(value);
      this.jiaolianPickerShow = false;
    },
    caipanRemove(index) {
      console.log('caipanRemove', index);
      this.formData.caipan.splice(index, 1);
      this.caipanPickerShow = false;
    },
    onCaipanAdd(value) {
      console.log('onCaipanAdd', value);
      let exist = this.formData.caipan.filter(item => {
        return item.num == value.num
      });
      if (exist.length > 0) {
        this.caipanPickerShow = false;
        return;
      }
      this.formData.caipan.push(value);
      this.caipanPickerShow = false;
    },

    phoneOptionLabel(opt) {
      return opt.c;
    },
    phoneOptionValue(opt) {
      return opt.c + '|' + opt.k;
    },
    stripPhonePreForPayload(val) {
      if (!val) {
        return '+86';
      }
      const s = String(val);
      const i = s.indexOf('|');
      if (i !== -1) {
        return s.slice(0, i);
      }
      return s;
    },
    normalizePhonePreAfterFetch() {
      let raw = this.formData.phone_pre;
      if (!raw) {
        this.$set(this.formData, 'phone_pre', '+86|中国');
        return;
      }
      raw = String(raw);
      if (raw.indexOf('|') !== -1) {
        const parts = raw.split('|');
        const dial = parts[0];
        const name = parts[1];
        const ok = PHONE_COUNTRY_OPTIONS.some((o) => o.c === dial && o.k === name);
        if (ok) {
          return;
        }
      }
      const dialOnly = raw.indexOf('|') !== -1 ? raw.split('|')[0] : raw;
      const matches = PHONE_COUNTRY_OPTIONS.filter((o) => o.c === dialOnly);
      if (matches.length >= 1) {
        this.$set(this.formData, 'phone_pre', matches[0].c + '|' + matches[0].k);
      } else {
        this.$set(this.formData, 'phone_pre', '+86|中国');
      }
    },
    validateContactFields() {
      const surname = (this.formData.surname || '').trim();
      const givenName = (this.formData.given_name || '').trim();
      const email = (this.formData.email || '').trim();
      const lxphone = (this.formData.lxphone || '').trim();
      const address = (this.formData.address || '').trim();
      if (!surname) {
        return '请输入姓';
      }
      if (!givenName) {
        return '请输入名';
      }
      if (!email) {
        return '请输入邮箱';
      }
      const emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (!emailReg.test(email)) {
        return '邮箱格式不正确';
      }
      if (!this.formData.phone_pre) {
        return '请选择地区代码';
      }
      if (!lxphone) {
        return '请输入电话号码';
      }
      if (!/^\d{6,20}$/.test(lxphone)) {
        // return '手机号格式不正确';
      }
      if (!address) {
        return '请输入协会地址';
      }
      return '';
    },
    memberFuncLabel(val) {
      if (val == null || val === '') {
        return '';
      }
      const s = String(val);
      const found = MEMBER_FUNCTION_OPTIONS.find((item) => item.value === s);
      return found ? found.label : s;
    },
    memberCitizenshipLabel(val) {
      const k = normalizeCitizenshipKey(val);
      return k !== null ? k : (val != null && val !== '' ? String(val) : '');
    },
    memberFileUploaded(list) {
      return Array.isArray(list) && list.length > 0 ? '已上传' : '-';
    },
    formatUsd(val) {
      return `${Number(val || 0).toFixed(2)} USD`;
    },
    mealStatusLabel(status) {
      if (!status || status === 'Draft') {
        return '草稿';
      }
      if (status === 'Saved') {
        return '已保存';
      }
      return status;
    },
    takeStatusLabel(status) {
      return this.mealStatusLabel(status);
    },
    fileUploadedLabel(uploaded) {
      return uploaded ? '已上传' : '-';
    },
    handleEdit(record) {
      let self = this
      this.visible = true
      getApplyDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.formData.id = record.id;
          self.formData = {...res.data};
          self.normalizePhonePreAfterFetch();
          const list = res.data.member_table_list || [];
          self.memberList = list.map((item, index) => normalizeMemberRowFromApi(item, index));
          self.roomBookingList = res.data.room_booking_list || [];
          self.roomBookingTotalQuantity = res.data.room_booking_total_quantity != null
            ? res.data.room_booking_total_quantity
            : self.roomBookingList.reduce((n, row) => n + Number(row.quantity || 0), 0);
          self.roomBookingTotalPrice = Number(res.data.room_booking_total_price || 0);
          self.mealReservationList = res.data.meal_reservation_list || [];
          self.mealReservationTotalQuantity = res.data.meal_reservation_total_quantity != null
            ? res.data.meal_reservation_total_quantity
            : self.mealReservationList.reduce((n, row) => n + Number(row.quantity || 0), 0);
          self.mealReservationTotalPrice = Number(res.data.meal_reservation_total_price || 0);
          self.takeServiceList = res.data.take_service_list || [];
          self.takePriceItems = res.data.take_price_items || [];
          self.takeServiceTotalPrice = Number(res.data.take_service_total_price || 0);
          self.visaList = res.data.visa_list || [];
          self.serviceList = res.data.editlist;
        }, 200)
      })
    },
    handleOrderEdit(record) {
      let self = this
      getApplyOrderDetail({baoming_id: record.id}).then(res => {
        self.orderVisible = true
        setTimeout(() => {
          self.orderFormData.id = record.id;
          console.log('handleEdit')
          self.orderFormData = {...res.data};
          self.orderFormData.refund_price_all = parseFloat(self.orderFormData.refund_price)+parseFloat(self.orderFormData.refund_price_off)
        }, 200)
      }).catch(err => {
        self.$message.error(err.data.msg);
      })
      // console.log(this.mdl)
    },

    refreshPrice() {
      let self = this
      refreshOrder({baoming_id: self.orderFormData.baoming_id}).then(res => {
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        });
      })
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh()
    },

    // 增改 处理
    handleOk(e) {
      const self = this;
      e.preventDefault();
      const validateMsg = self.validateContactFields();
      if (validateMsg) {
        self.$message.warning(validateMsg);
        return;
      }
      self.saveLoading = true;
      editApply({
        id: self.formData.id,
        surname: (self.formData.surname || '').trim(),
        given_name: (self.formData.given_name || '').trim(),
        email: (self.formData.email || '').trim(),
        phone_pre: self.stripPhonePreForPayload(self.formData.phone_pre),
        lxphone: (self.formData.lxphone || '').trim(),
        address: (self.formData.address || '').trim(),
        memberstatus: self.formData.memberstatus,
      }).then(() => {
        self.$message.success('修改成功');
        self.$refs.table.refresh();
        self.visible = false;
        self.saveLoading = false;
      }).catch((err) => {
        self.$message.error(err.data.msg);
        self.saveLoading = false;
      });
    },
    // 增改 处理
    handleOrderOk(e) {
      let self = this;
      e.preventDefault();

      self.saveLoading = true;
      editApplyOrder({
        id: self.orderFormData.id,
        baoming_id: self.orderFormData.baoming_id,
        status: self.orderFormData.status,
        adminnote: self.orderFormData.adminnote,
        pay_off_date: self.orderFormData.pay_off_date,
        pay_off_id: self.orderFormData.pay_off_id,
        refund_price_off: self.orderFormData.refund_price_off,
        adminnote: self.orderFormData.adminnote,
        memberprice: self.orderFormData.memberprice,
        pay_price: self.orderFormData.pay_price,
        diyprice: self.orderFormData.diyprice,
        pics: self.orderFormData.pics,
        pay_code: self.orderFormData.pay_code,
        payed_price_offline: self.orderFormData.payed_price_offline,
      }).then(res => {
        self.$message.success('修改成功')
        self.$refs.table.refresh()
        self.orderVisible = false;
        self.saveLoading = false;
      }).catch(err => {
        self.$message.error(err.data.msg);
        self.saveLoading = false;
      })
    },

    // 删
    applyDelete(record) {
      let self = this
      applyDelete({id: record.id}).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh()
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },


    handleEditDo(id, status) {
      let self = this
      editDo({id: id, status: status}).then(res => {
        self.$message.success('操作成功')
        self.handleEdit({
          id: self.formData.id
        })
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    download(type) {
      console.log('this.queryParam')
      console.log(this.queryParam)
      if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
        this.$message.error('请先选择赛区');
        return;
      }
      let keys = JSON.stringify(this.selectedRowKeys)
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/sai/hotelmingxitable?saiqu=' + this.queryParam.sjsq[1]);
          break;
        case 2:
          window.open(setting.apiBaseURL + '/adminapi/sai/hotelhuizongtable?saiqu=' + this.queryParam.sjsq[1]);
          break;


        case 3:
          //接送服务明细表
          window.open(setting.apiBaseURL + '/adminapi/sai/jiesongmingxitable?saiqu=' + this.queryParam.sjsq[1]);
          break;
        case 4:
          //签证信息明细表
          window.open(setting.apiBaseURL + '/adminapi/sai/qianzhengmingxitable?saiqu=' + this.queryParam.sjsq[1]);
          break;


        // case 3:
        //   window.open(setting.apiBaseURL + '/adminapi/sai/rysfzDownload?saiqu=' + this.queryParam.sjsq[1] +'&keywords='+this.queryParam.keywords);
        //   break;
        // case 4:
        //   window.open(setting.apiBaseURL + '/adminapi/sai/csrstjDownload?saiqu=' + this.queryParam.sjsq[1]);
        //   break;
        case 5:
          window.open(setting.apiBaseURL + '/adminapi/sai/zhixuceDownload?saiqu=' + this.queryParam.sjsq[1] + '&memberstatus=' + (this.queryParam.memberstatus || 0));
          break;
        case 6: 
            // return
          window.open(setting.apiBaseURL + '/adminapi/sai/jiaofeiDownload?saiqu=' + this.queryParam.sjsq[1] + '&keys=' + keys);
          break;
        case 7:
          // window.open(setting.apiBaseURL+'/adminapi/sai/jiaolianDownload?saiqu='+this.queryParam.sjsq[1]);
          window.open(setting.apiBaseURL + '/adminapi/dscore/scoreRewardDownload?saiqu=' + this.queryParam.sjsq[1]);
          break;
        case 8:
          // window.open(setting.apiBaseURL+'/adminapi/sai/jiaolianDownload?saiqu='+this.queryParam.sjsq[1]);
          window.open(setting.apiBaseURL + '/adminapi/sai/jiaofeiTotalDownload?saiqu=' + this.queryParam.sjsq[1]);
          break;
        case 9: 
            // return
          window.open(setting.apiBaseURL + '/adminapi/sai/fapiaoExport?saiqu=' + this.queryParam.sjsq[1] + '&keys=' + keys);
          break;
        case 10: 
            // return
          window.open(setting.apiBaseURL + '/adminapi/sai/jiaofeiShisuDownload?saiqu=' + this.queryParam.sjsq[1] + '&keys=' + keys);
          break;

      }
    },
    onFapiaoDownload(record) {
      window.open(record.pdf_url);
    },
    onRefundDownload(id){
          window.open(setting.apiBaseURL + '/adminapi/sai/refunddetailDownload?id=' + id);
    },
    onFapiaoZuofei(record) {
      let self = this
      fapiaoZuofei({id: record.id}).then(res => {
        self.handleEdit({id: record.baoming_id})
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    onFapiaoDelete(record) {
      let self = this
      fapiaoDelete({id: record.id}).then(res => {
        self.handleEdit({id: record.baoming_id})
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    onKaipiao(record) {
      let self = this
      kaipiao({id: record.id}).then(res => {
        self.handleEdit({id: record.baoming_id})
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },
    onRefreshFapiao(record) {
      let self = this
      refreshFapiao({fapiao_id: record.id}).then(res => {
        self.handleEdit({id: record.baoming_id})
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },


    onBuRefund(record) {
      console.log('pay_price', record)
      this.orderBuFormData = record
      this.refundBuVisible = true;
      this.refund_price = '';
      this.refund_comment = '';
      this.refund_mima = '';
    },
    onRefund() {
      this.refundVisible = true;
      this.refund_price = '';
      this.refund_comment = '';
      this.refund_mima = '';
    },
    onRefundApply(type,bu_id) {
      this.refundApplyVisible = true;
      this.refund_apply_comment = '';
      this.refund_apply_price = '';
      this.refund_apply_card = '';
      this.refund_apply_account = '';
      this.refund_apply_bank = '';
      this.refund_apply_type = type;
      this.refund_order_bu_id = bu_id;
    },
    onSubjectApply() {
      // self.orderFormData.baoming_id
      const {href} = this.$router.resolve({name:'ApplySubjectList',query:{baoming_id: this.orderFormData.baoming_id}});
      window.open(href, '_blank');
    },
    handleRefundCancel() {
      this.refundVisible = false;
      this.refund_price = '';
    },
    handleRefundApplyCancel() {
      this.refundApplyVisible = false;
      this.refund_apply_comment = '';
      this.refund_apply_price = '';
      this.refund_apply_account = '';
      this.refund_apply_bank = '';
      this.refund_apply_card = '';
      this.refund_apply_type = '';
      this.refund_order_bu_id = '';
    },
    onRefundRefuse(bu_id) {
      let self = this;
      orderRefundRefuse({
        order_id: self.orderFormData.id,
        order_bu_id: bu_id
      }).then(res => {
        self.saveLoading = false;
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    onRefund2023(id) {
      let self = this;
      console.log('pay_password',self.pay_password)
      if(self.pay_password !='ccatuikuan123'){
        self.$message.error('密码错误')
        return 
      }
        // self.$message.success('密码正确')
        self.pay_password = ''
      // return ;
      orderRefund2023({
        id: id
      }).then(res => {
        self.saveLoading = false;
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    onRefundRefuse2023(id) {
      let self = this;
      orderRefundRefuse2023({ 
        id: id
      }).then(res => {
        self.saveLoading = false;
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    handleRefundOk() {
      let self = this
      if (self.refund_price == 0) {
        self.$message.error('请输入退款金额')
        return;
      }
      if (self.refund_comment == '') {
        self.$message.error('请填写理由')
        return;
      }
      if (self.refund_mima == '') {
        self.$message.error('请填写密码')
        return;
      }
      if(self.refund_mima !='ccatuikuan123'){
        self.$message.error('密码错误')
        return;
      }
      self.refund_mima = ''
      self.saveLoading = true;
      orderRefund({
        order_id: self.orderFormData.id,
        price: self.refund_price,
        comment: self.refund_comment,
        password: self.refund_mima,
      }).then(res => {
        self.refundVisible = false;
        self.saveLoading = false;
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    handleBuRefundOk() {
      let self = this
      if (self.refund_price == 0) {
        self.$message.error('请输入退款金额')
        return;
      }
      if (self.refund_comment == '') {
        self.$message.error('请填写理由')
        return;
      }
      if (self.refund_mima == '') {
        self.$message.error('请填写密码')
        return;
      }
      if(self.refund_mima !='ccatuikuan123'){
        self.$message.error('密码错误')
        return;
      }
      self.refund_mima = ''
      self.saveLoading = true;
      orderBuRefund({
        order_id: self.orderBuFormData.id,
        price: self.refund_price,
        comment: self.refund_comment,
        password: self.refund_mima,
      }).then(res => {
        self.refundBuVisible = false;
        self.saveLoading = false;
        self.$message.success("退款成功")
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    handleRefundApplyOk() {
      let self = this
      if (self.refund_apply_comment == '') {
        self.$message.error('请填写理由')
        return;
      }
      if (self.refund_apply_price <=0) {
        self.$message.error('请填写金额')
        return;
      }
      if (self.refund_apply_type==2 && !self.refund_apply_card) {
        self.$message.error('请填写卡号')
        return;
      }
      if (self.refund_apply_type==2 && !self.refund_apply_bank ) {
        self.$message.error('请填写开户行')
        return;
      }
      if (self.refund_apply_type==2 && !self.refund_apply_account ) {
        self.$message.error('请填写账户名')
        return;
      }
      self.saveLoading = true;
      orderRefundApply({
        baoming_id:self.orderFormData.baoming_id,
        order_id: self.orderFormData.id,
        order_bu_id: self.refund_order_bu_id,
        type: self.refund_apply_type,
        card: self.refund_apply_card,
        bank: self.refund_apply_bank,
        account: self.refund_apply_account,
        comment: self.refund_apply_comment,
        price: self.refund_apply_price,
      }).then(res => {
        self.refundApplyVisible = false;
        self.saveLoading = false;
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

    onCopy(e) {
      this.$message.success('复制成功')
    },
    onError(e) {
      this.$message.error('复制失败')
    },
    setBuPrice() {
      let self = this;
      setBuPrice({
        baoming_id: self.orderFormData.baoming_id,
        price: self.buPrice,
        note: self.buNote,
      }).then(res => {
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    buOrderDelete(record) {
      let self = this;
      buOrderDelete({
        id: record.id,
      }).then(res => {
        self.handleOrderEdit({
          id: self.orderFormData.baoming_id
        })
      }).catch(err => {
        self.saveLoading = false;
        self.$message.error(err.data.msg)
      })
    },
    handleshisuurl(){
      // console.log(setting.pcBaseURL+'/cca-www/dist/isai-apply-form-step-3-admin?id='+this.formData.id);
      // return ;
      window.open(setting.pcBaseURL+'/jianqiu-www/dist/isai-apply-form-step-3-admin?id='+this.formData.id)
    },

    fapiaoMxNumChange(){ 
      let total = 0; 
      this.formFapiaoShenqingData.list.map(item =>{
          item.total = (item.price*item.num).toFixed(2)
          total += parseFloat(item.total);
      })
      this.formFapiaoShenqingData.total = total 
    },

    fapiaoMxTotalChange(){ 
      let total = 0; 
      this.formFapiaoShenqingData.list.map(item =>{
          item.price = (item.total/item.num).toFixed(2)
            
          total += parseFloat(item.total);
      })
      this.formFapiaoShenqingData.total = total 
    },

    beforeFapiaoUpload(file) {
      let that = this
      let formdata = new FormData()
      console.log(file)
      formdata.append('upfile', file)
      formdata.append('action', 'test')
      console.log('formdata', formdata)

      let fapiaoList = [];
      this.file2Xce(file).then(tabJson => {
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log('this.xlsxJson', tabJson);
          // return ;
          tabJson[0].sheet.map((item, index) => {
            // console.log(item,index);
            if (item['pdf网址']) { 
              fapiaoList.push({ 
                fapiao_id: item['发票id']||'',
                baoming_id: item['报名id']||'', 
                fapiao_taitou: item['抬头']||'',
                fapiao_shuihao: item['税号']||'',
                fapiao_tel: item['电话']||'',
                fapiao_address: item['地址']||'',
                fapiao_account: item['开户行及账号']||'',
                fapiao_beizhu: item['备注']||'',
                invoiceCode: item['发票代码']||'',
                invoiceNum: item['发票号码']||'',
                pdf_url: item['pdf网址']||'',
              });
            }
          })

          console.log('fapiaoList', fapiaoList);
          // return

          fapiaoImport({
            list:JSON.stringify(fapiaoList)
          })
            .then(res => {
              that.$message.success('上传成功')
              that.$refs.table.refresh(false)
            })
            .catch(err => {
              that.$message.error(err.data.msg)
            })
 
        }
      });

      // return ;

      
      return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

  },
  filters: {},
  watch: {  
    'orderFormData.diyprice':{

        handler(newV, oldV) { 
            this.orderFormData.shisu_total = parseFloat(newV)+ parseFloat(this.orderFormData.shisuprice)
        },
        immediate: true,
        deep: true
    }
  },
}
</script>
